module.exports = __webpack_public_path__ + "img/60.08078854.jpg";